// extracted by mini-css-extract-plugin
export default {"disposableList":"DisposableList_disposableList__t95wv"};